module.exports = __webpack_public_path__ + "static/img/zj001.eaad0bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/zj001.png
// module id = JZID
// module chunks = 1